import React from "react";
import "../components.css";

export default function Button ({label = "Label", width = "25vw", height = "25vh", color = "black", pressColor = "gray", onChange = () => {console.log("No function given")}}) {
    const [style, setStyle] = React.useState({backgroundColor: color});

    var tileStyle = {
        width: width,
        height: height
    }

    function click() {
        onChange();
        setStyle({backgroundColor: pressColor});
        setTimeout(() => {
            setStyle({backgroundColor: color});
        }, 100);
    }

    return (
        <div className="tile" style={tileStyle}>
            <div id="tilePress" onClick={() => click()} style={style}>
                <h1>{label}</h1>
            </div>
        </div>
    )
}